const cars = [
  {
    id: 1,
    name: "GLE 6.3S AMG ",
    engine: "6.3 Petrol",
    transmission: "Automat",
    price: 200,
    category: "Luxury",
    images: [
      "/images/cars/gle.jpg?v=2",
      "/images/cars/gle1.jpg?v=2",
      "/images/cars/gle2.jpg?v=2",
      "/images/cars/gle3.jpg?v=2",
      "/images/cars/gle4.jpg?v=2",
    ],
  },

  {
    id: 2,
    name: "Audi A8 L",
    engine: "3.0 Diesel",
    transmission: "Automat",
    price: 110,
    category: "Luxury",
    images: [
      "/images/cars/a8.jpg",
      "/images/cars/a81.jpg",
      "/images/cars/a82.jpg",
      "/images/cars/a83.jpg",
    ],
  },

  {
    id: 3,
    name: "Audi Q7",
    engine: "3.0 Diesel",
    transmission: "Automat",
    price: 110,
    category: "Luxury",
    images: [
      "/images/cars/q7.jpg?v=2",
      "/images/cars/q72.jpg?v=2",
      "/images/cars/q73.jpg?v=2",
    ],
  },

  {
    id: 4,
    name: "Range Rover Vogue",
    engine: "3.0 Diesel",
    transmission: "Automat",
    price: 110,
    category: "Luxury",
    images: [
      "/images/cars/vogue.jpg",
      "/images/cars/vogue1.jpg",
      "/images/cars/vogue2.jpg",
      "/images/cars/vogue3.jpg",
      "/images/cars/vogue4.jpg",
    ],
  },

  {
    id: 5,
    name: "Mercedes S-Class",
    engine: "5.0 Petrol",
    transmission: "Automat",
    price: 90,
    category: "Luxury",
    images: [
      "/images/cars/sclass.jpg",
      "/images/cars/sclass1.jpg",
      "/images/cars/sclass2.jpg",
    ],
  },

  {
    id: 6,
    name: "Mercedes Benz Viano",
    engine: "3.0 Diesel",
    transmission: "Automat",
    price: 80,
    category: "Luxury",
    seats: "7+1",
    images: [
      "/images/cars/viano.jpg?v=2",
      "/images/cars/viano1.jpg?v=2",
      "/images/cars/viano2.jpg?v=2",
      "/images/cars/viano3.jpg?v=2",
      "/images/cars/viano4.jpg?v=2",
    ],
  },

  {
    id: 7,
    name: "Porsche Cayenne",
    engine: "3.0 Diesel",
    transmission: "Automat",
    price: 65,
    category: "Luxury",
    images: [
      "/images/cars/porche.jpg",
      "/images/cars/porche1.jpg",
      "/images/cars/porche2.jpg",
      "/images/cars/porche3.jpg",
    ],
  },

  {
    id: 9,
    name: "Range Rover Evoque",
    engine: "2.0 Diesel",
    transmission: "Automat",
    price: 50,
    category: "Economic",
    images: [
      "/images/cars/nafte.jpg",
      "/images/cars/nafte1.jpg",
      "/images/cars/nafte2.jpg",
      "/images/cars/nafte3.jpg",
    ],
  },

  {
    id: 11,
    name: "Audi Q5",
    engine: "2.0 Petrol",
    transmission: "Automat",
    price: 45,
    category: "Economic",
    images: [
      "/images/cars/q5.jpg",
      "/images/cars/q51.jpg",
      "/images/cars/q52.jpg",
      "/images/cars/q53.jpg",
    ],
  },

  {
    id: 12,
    name: "Audi A6",
    engine: "2.0 Diesel",
    transmission: "Automat",
    price: 45,
    category: "Economic",
    images: [
      "/images/cars/a6.jpg",
      "/images/cars/a62.jpg",
      "/images/cars/a63.jpg",
    ],
  },

  {
    id: 13,
    name: "Skoda Superb",
    engine: "2.0 Diesel",
    transmission: "Automat",
    price: 40,
    category: "Economic",
    images: [
      "/images/cars/skoda.jpg",
      "/images/cars/skoda1.jpg",
      "/images/cars/skoda2.jpg",
    ],
  },

  {
    id: 14,
    name: "Passat R-Line",
    engine: "2.0 Diesel",
    transmission: "Manual",
    price: 40,
    category: "Economic",
    images: [
      "/images/cars/rline.jpg",
      "/images/cars/rline2.jpg",
      "/images/cars/rline3.jpg",
      "/images/cars/rline4.jpg",
    ],
  },

  {
    id: 15,
    name: "Volkswagen T-Roc",
    engine: "1.0 Petrol",
    transmission: "Manual",
    price: 40,
    category: "Economic",
    images: [
      "/images/cars/troc.jpg",
      "/images/cars/troc2.jpg",
    ],
  },

  {
    id: 17,
    name: "Passat",
    engine: "2.0 Diesel",
    transmission: "Automat",
    price: 30,
    category: "Economic",
    images: [
      "/images/cars/gri.jpg",
      "/images/cars/gri1.jpg",
      "/images/cars/gri2.jpg",
      "/images/cars/gri3.jpg",
    ],
  },

  {
    id: 19,
    name: "Ford Focus",
    engine: "2.0 Diesel",
    transmission: "Automat",
    price: 20,
    category: "Economic",
    images: [
      "/images/cars/ford.jpg?v=2",
      "/images/cars/ford1.jpg?v=2",
      "/images/cars/ford2.jpg?v=2",
    ],
  },
];

export default cars;